import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/admin/')({
  component: () => <Navigate to="/admin/evaluations" />,
})
